// Shared utility for handling economic model form logic in modals
export default class EconomicModelFormHandler {
  static setup(formSelector = '#sr-form') {
    const locationRadio = $('#economic-model-location');
    const iruRadio = $('#economic-model-iru');
    const recurrentPriceLabel = $('#recurrent-price-label');
    const iruFieldContainer = $('#iru-field-container');

    const updateFormFields = () => {
      const isIru = iruRadio.is(':checked');
      // Update recurrent price label: Location → Abonnement, IRU → Maintenance
      recurrentPriceLabel.text(isIru ? I18n.t('backoffice.custom_pricing.maintenance', { defaultValue: 'Maintenance' }) : I18n.t('backoffice.study_requests.custom_pricing.subscription'));
      
      // Show/hide IRU field based on economic model
      if (iruFieldContainer.length) {
        if (isIru) {
          iruFieldContainer.show();
          iruFieldContainer.find('input').prop('required', true);
        } else {
          iruFieldContainer.hide();
          iruFieldContainer.find('input').prop('required', false).val('');
        }
      }
    };

    $(formSelector).on('submit', function(e) {
      if (!this.checkValidity()) {
        e.preventDefault();
        e.stopPropagation();
        this.classList.add('was-validated');
        // Optionally, scroll to the first invalid field
        const firstInvalid = this.querySelector(':invalid');
        if (firstInvalid) {
          firstInvalid.scrollIntoView({ behavior: 'smooth', block: 'center' });
          firstInvalid.focus();
        }
        return false;
      }
    });

    locationRadio.on('change', updateFormFields);
    iruRadio.on('change', updateFormFields);
    updateFormFields();
  }
}